import React, { useEffect, useState } from "react";
import { PAGESIZE } from "../../../utils/constants";
import { StorageItems } from "../../../utils/storageItems";
import { DataSelectType } from "../../../models/DataSelectType";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import { TicketFinancialType } from "../../../enums/ticketFinancialType";
import CardViewForm from "./CardForm/CardViewForm";
import TableViewForm from "./Components/TableForm/TableViewForm";

export type FormViewType = "CardView" | "TableView";
export const Tickets = () => {
  const storedPage = localStorage.getItem(StorageItems.TicketPage);
  const storedPageSize = localStorage.getItem(StorageItems.TicketPageSize);
  const storageFormView = localStorage.getItem(StorageItems.TicketView) as FormViewType | null;

  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PAGESIZE);

  const [loading, setLoading] = useState<boolean>(false);
  const [formView, setFormView] = useState<FormViewType>(storageFormView ?? "TableView");
  const [openFeedback, setOpenFeedback] = useState<boolean>(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<DataSelectType[]>();
  const [form, setForm] = useState<TicketInterface>({
    id: "",
    title: "",
    asset: null,
    statusId: "",
    companyId: '',
    assetId: null,
    categoryId: "",
    locationId: "",
    priorityId: "",
    customerId: "",
    description: "",
    contractorId: "",
    departmentId: "",
    assignedTo: null,
    author: undefined,
    dueDate: undefined,
    assignedToId: null,
    isRecurring: false,
    interventionTypeId: "",
    financialAssignedTo: null,
    financialAssignedToId: null,
    ticketFinancialType: TicketFinancialType.Nonbillable,
    isMasterTicket: false,
    masterTicketId: '',
  });

  localStorage.setItem(StorageItems.TicketPage, page.toString());
  localStorage.setItem(StorageItems.TicketPageSize, pageSize.toString());

  useEffect(() => {
    setTimeout(() => {
      const previousLocation = localStorage.getItem('PreviousLocation');
      const isNotTicketPath = !['/tickets/', '/ticket/'].some(path => previousLocation?.includes(path));

      if (previousLocation === '') {
        setPage(storedPage ? parseInt(storedPage) : 1);
        setPageSize(storedPageSize ? parseInt(storedPageSize) : 20);
      }
      else if (isNotTicketPath) {
        setPage(1);
        setPageSize(PAGESIZE);
      } else {
        setPage(storedPage ? parseInt(storedPage) : 1);
        setPageSize(storedPageSize ? parseInt(storedPageSize) : 20);
      }
    }, 100);
  }, []);

  const handleFeedback = () => setOpenFeedback(true);

  return formView === "CardView"
    ? <CardViewForm
      page={page}
      pageSize={pageSize}
      formView={formView}
      filterData={filterData}
      selectedIds={selectedIds}
      showFilters={showFilters}
      setPage={setPage}
      setFormView={setFormView}
      setPageSize={setPageSize}
      setFilterData={setFilterData}
      setSelectedIds={setSelectedIds}
      setShowFilters={setShowFilters}
    />
    : <TableViewForm
      page={page}
      form={form}
      loading={loading}
      pageSize={pageSize}
      formView={formView}
      filterData={filterData}
      showFilters={showFilters}
      openFeedback={openFeedback}
      setForm={setForm}
      setPage={setPage}
      setPageSize={setPageSize}
      setFormView={setFormView}
      setFilterData={setFilterData}
      handleFeedback={handleFeedback}
      setShowFilters={setShowFilters}
      setOpenFeedback={setOpenFeedback}
    />
};
export default Tickets;
